import React, { useState, useEffect } from 'react';
import { getLogs } from '../../services/adminApi';
import AdminLayout from '../../components/admin/AdminLayout';

const DeletedLogsPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    page: 1,
    limit: 20,
    action: 'delete',
  });
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchLogs = async () => {
      setLoading(true);
      try {
        const response = await getLogs(filters);
        if (response.data.success) {
          setLogs(response.data.data);
          setTotalPages(response.data.totalPages);
        }
      } catch (error) {
        console.error('Failed to fetch logs', error);
      }
      setLoading(false);
    };
    fetchLogs();
  }, [filters]);

  const handlePageChange = (newPage) => {
    setFilters({ ...filters, page: newPage });
  };

  return (
    <AdminLayout>
      <div className="container mx-auto p-4">
        <h1 className="text-2xl font-bold mb-4">Deleted Item Logs</h1>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white">
                <thead>
                  <tr>
                    <th className="py-2 px-4 border-b">Timestamp</th>
                    <th className="py-2 px-4 border-b">Message</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.map((log) => (
                    <tr key={log._id}>
                      <td className="py-2 px-4 border-b">{new Date(log.created_at).toLocaleString()}</td>
                      <td className="py-2 px-4 border-b">
                        {log.entity_type} '{log.entity_name}' was deleted by {log.user_name || log.user_id?.email}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="mt-4 flex justify-between items-center">
              <button
                onClick={() => handlePageChange(filters.page - 1)}
                disabled={filters.page <= 1}
                className="p-2 border rounded"
              >
                Previous
              </button>
              <span>
                Page {filters.page} of {totalPages}
              </span>
              <button
                onClick={() => handlePageChange(filters.page + 1)}
                disabled={filters.page >= totalPages}
                className="p-2 border rounded"
              >
                Next
              </button>
            </div>
          </>
        )}
      </div>
    </AdminLayout>
  );
};

export default DeletedLogsPage;
